import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';

import errorImg from '../../../images/error-unplug.png';

import styles from './SomethingWentWrong.css';


function SomethingWentWrong({ text, buttonLabel, onClick }) {
  return (
    <div className={styles.container}>
      <img alt="error" src={errorImg} />
      <p>{text}</p>
      <Button colour="white" label={buttonLabel} onClick={onClick} />
    </div>
  );
}

SomethingWentWrong.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SomethingWentWrong;
